<template>

    <div class="reg-text-notice">
        Ваш e-mail подтвержден. Теперь Вы можете
        <router-link to="/login">войти</router-link>
        в веб интерфейс управления и использовать его для
        авторизации в приложении.
    </div>

</template>

<style scoped>
    a{
        color: #5EA9FF;
    }
</style>
<script>
    export default {
        data() {
            return {}
        },
    }
</script>
